import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import { Center, Spinner } from "@chakra-ui/react";

const GuestRoute = () => {
    return (
        <Suspense
            fallback={
                <Center width='100%' height='100vh'>
                    <Spinner />
                </Center>
            }
        >
            <Outlet />
        </Suspense>
    )
};

export default GuestRoute;